"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuestUserRegistrationResult = void 0;
var GuestUserRegistrationResult;
(function (GuestUserRegistrationResult) {
    GuestUserRegistrationResult["successful"] = "successful";
    GuestUserRegistrationResult["alreadyRegistered"] = "alreadyRegistered";
})(GuestUserRegistrationResult || (exports.GuestUserRegistrationResult = GuestUserRegistrationResult = {}));
//# sourceMappingURL=GuestUserRegistrationResult.js.map